export default [
    // packages ordered by priority
    "HTT",
    "HTTF",
    "PFTT",
    "PFTTF",
    "PFPTTF",
    "PFTTNL",
    "PFPTTNL",
    "PFTT_7",
    "PFTT_8",
];
